import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClienteAnaliseMercadoRAPViewComponent } from '../views/rap';
import { ClienteAnaliseMercadoViewComponent } from '../views/view/cliente-analise-mercado-view.component';
import { CanActivateClienteAnaliseMercado } from './can-activate-cliente-analise-mercado';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateClienteAnaliseMercado],
                component: ClienteAnaliseMercadoViewComponent,
                children: [
                    {
                        path: 'rap',
                        component: ClienteAnaliseMercadoRAPViewComponent
                    },
                    {path: '', redirectTo: 'rap', pathMatch: 'full'}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateClienteAnaliseMercado
    ]
})
export class ClienteAnaliseMercadoRoutingModule { }
